<template>
  <b-card>
    <div class="px-3 py-2">
      <filter-rules
        :filters="filters"
        :logic="logic"
        :show-errors="showErrors"
        :key="key"
        @patch="onFilterRulesPatch"/>
    </div>
    <div class="buttons px-3 py-2">
      <b-row>
        <b-col :sm="4">
          <b-button variant="outline-secondary" @click="onClear">
            Clear Filters
          </b-button>
        </b-col>
        <b-col :sm="8" class="text-right">
          <b-button variant="outline-primary" @click="onSave" disabled>
            Save & Apply
          </b-button>
          <b-button variant="outline-primary" @click="onApply">
            Apply
          </b-button>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
	import FilterRules from '../FilterRules';

	export default {
		name: 'DynamicRules',
		components: {FilterRules},

		data() {
			return {
				key: 1,
				filters: [],
				logic: null,
				complete: false,
				showErrors: false
			};
		},

		methods: {
			onFilterRulesPatch(patch) {
				this.complete = patch.complete;
				this.filters = patch.filters || this.filters;
				this.logic = patch.logic || this.logic;
			},

			onClear() {
				this.filters = [];
				this.logic = null;
				this.complete = false;
				this.key = this.key + 1;
			},

			onApply() {
				if (!this.complete) {
					this.showErrors = true;
					return;
				}

				this.$emit('apply', {
					filters: this.filters,
					logic: this.logic
				});
			},

      onSave() {
				this.onApply();
      }
		}
	};
</script>

<style scoped>
  .buttons {
    border-top: 1px solid gray;
  }
</style>
